module.exports = __webpack_public_path__ + "static/media/HipAbductionFemale.8967825f.svg";